import React, { useRef, useEffect, useState } from "react";
import "./index.css";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Navbar, Nav, NavDropdown, Form } from "react-bootstrap";
import logo from "~/app/assets/images/logo.svg";
import avatar from "~/app/assets/images/no-avatar.png";
import {
  updateSidebarCollapse,
  updateSidebarToggle,
} from "../sidebar/services";
import { getUserInformation } from "../../../modules/authentication/services";
import { fetchTimeZone, setStoreTimeZone } from "./services";
import Toast from "../toast";
import Select from "react-select";
import Provider from "~shared/singleton";
import { findURLParam } from "../../utils/urls";
import {eraseCookie, getCookie, setCookie} from "../../utils/cookie";
const providerInstance = Provider.getInstance();
// const schemaName = "islandpetcenter";
const Header = ({
  collapseSidebar,
  toggleSidebar,
  collapsed,
  toggled,
  fetchUserInformation,
  authentication_state,
  fetchTimeZoneList,
  time_zone_list_state,
  set_time_zone_state,
  sendTimeZoneStoreId,
}) => {
  const authentication_ref = useRef(authentication_state);
  authentication_ref.current = authentication_state;

  const time_zone_list_ref = useRef(time_zone_list_state);
  time_zone_list_ref.current = time_zone_list_state;

  const set_time_zone_ref = useRef(set_time_zone_state);
  set_time_zone_ref.current = set_time_zone_state;

  const [timeZoneList, setTimeZoneList] = useState([]);
  const [selectedTimeZone, setSelectedTimeZone] = useState("");
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  // const [update, setUpdate] = useState(false);
  const getTimeZone = (schemaName) => {
    fetchTimeZoneList(schemaName).then(() => {
      if (!time_zone_list_ref.current?.time_zone_list?.hasError) {
        setTimeZoneList(time_zone_list_ref.current.time_zone_list.response);
        setSelectedStoreId(
          authentication_ref.current?.user_info?.response?.timezone_store_id
        );
      } else {
        Toast.error(
          time_zone_list_ref.current?.time_zone_list?.error?.data ||
            "Something went wrong."
        );
      }
    });
  };
  // handle dropdown selection
  const handleSelect = (e) => {
    setSelectedTimeZone(e);
    const location = window.location.href;
    const schema =
      providerInstance.getSchema() !== null
        ? providerInstance.getSchema()
        : getCookie("schema_name");

    /* @TODO */
    // setCookie('time_zone',e.timezone)
    setCookie('time_zone', 'UTC')
    // setCookie('time_zone_id',e.id)

    // sendTimeZoneStoreId(schema, e.id).then(() => {
    //   if (!set_time_zone_ref.current?.set_time_zone?.hasError) {
    //     setSelectedStoreId(
    //       set_time_zone_ref.current.set_time_zone.response.store_id
    //     );
    //     // setUpdate(true);
    //   } else {
    //     Toast.error(
    //       set_time_zone_ref.current?.set_time_zone?.error?.data ||
    //         "Something went wrong. Please try Again."
    //     );
    //   }
    // });
  };
  const handleLogout = () => {
    localStorage.clear();
    eraseCookie('tokenExpiration')
  };
  const fetchDetails = () => {
    if (
        getCookie("refresh_token")
    ) {
      const location = window.location.href;
      const schemaName = findURLParam("schema_name", location)
        ? findURLParam("schema_name", location)
        : getCookie("schema_name");
      const sessionKey = findURLParam("session_key", location)
        ? findURLParam("session_key", location)
        : getCookie("session_key");
      fetchUserInformation(schemaName, sessionKey);
      getTimeZone(schemaName);
    }
  };
  useEffect(() => {
    if (
      authentication_ref?.current?.retailer_info?.response?.schema_name !== null
    ) {
      fetchDetails();
    }
  }, [authentication_ref?.current?.retailer_info?.response?.schema_name]);
  useEffect(() => {
    if(selectedStoreId){
      const userStore = timeZoneList.filter(
        (storeItem) => storeItem.id == selectedStoreId
      );
      setSelectedTimeZone(userStore);
    }else {
      setSelectedTimeZone(timeZoneList[0]);
    }
    // using the id for preselecting the data timezone may have multiple instance so using id would be better
    /* @TODO */
   /*  if (getCookie('time_zone_id')) {
      var selected_timezone= timeZoneList.filter(
          (item) => item.id == getCookie('time_zone_id')
      )
      setSelectedTimeZone(selected_timezone)
    } */
  }, [selectedStoreId, timeZoneList]);
  // useEffect(() => {
  //   if (update) {
  //     fetchDetails();
  //     setUpdate(false)
  //   }
  // }, [update]);
  const onSliderMenuPress = () => {
    if (window.matchMedia("(max-width: 991px)").matches) {
      toggleSidebar(!toggled);
      if (collapsed) collapseSidebar(false);
    } else collapseSidebar(!collapsed);
  };

  return (
    <header className="header">
      <Navbar bg="light" expand="xl">
        {/* <Navbar.Brand>
          <img className="head-prof-img" src={logo} alt="logo" width="" />
        </Navbar.Brand> */}
        <Navbar.Brand>
          <div className="navbar-logo-container">
            <a
              href={`https://${authentication_ref?.current?.retailer_info?.response?.domain_url}/retailer/dash/`}
            >
              <img
                className="head-prof-img navbar-logo-image"
                src={authentication_ref.current?.retailer_info?.response?.logo ? (authentication_ref.current?.retailer_info?.response?.logo+"?"+performance.now()) : ""}
                alt=""
                width=""
              />
            </a>
          </div>
        </Navbar.Brand>
        <div>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <svg width="5" height="21" viewBox="0 0 5 21">
              <g
                id="Group_328"
                data-name="Group 328"
                transform="translate(-745 -345)"
              >
                <circle
                  id="Ellipse_234"
                  data-name="Ellipse 234"
                  cx="2.5"
                  cy="2.5"
                  r="2.5"
                  transform="translate(745 345)"
                  fill="#333"
                />
                <circle
                  id="Ellipse_235"
                  data-name="Ellipse 235"
                  cx="2.5"
                  cy="2.5"
                  r="2.5"
                  transform="translate(745 353)"
                  fill="#333"
                />
                <circle
                  id="Ellipse_236"
                  data-name="Ellipse 236"
                  cx="2.5"
                  cy="2.5"
                  r="2.5"
                  transform="translate(745 361)"
                  fill="#333"
                />
              </g>
            </svg>
          </Navbar.Toggle>
        </div>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto"></Nav>
          <Form inline>
            <div className="d-flex pt-2 pb-2">
              {/* commenting as it would be need for future purpose in the product */}
              {/* <label className="mr-2">Time zone:</label>
              <Select
                className="select-time-zone-list"
                isMulti={false}
                getOptionLabel={(item) => `${item.name} (${item.timezone})`}
                getOptionValue={(item) => item.id}
                placeholder="Select Time Zone"
                onChange={handleSelect}
                value={selectedTimeZone}
                options={timeZoneList}
              /> */}
              {/* <NavDropdown
                title="Select Time Zone"
                id="basic-nav-dropdown"
                className="normal-dropdown brdr-drpdwn"
              >
                {timeZoneList.map((timeZone) => (
                  <NavDropdown.Item
                    eventKey={timeZone.id}
                    onSelect={handleSelect}
                  >
                    {timeZone.name}
                  </NavDropdown.Item>
                ))}
              </NavDropdown> */}
            </div>
            <div className="d-flex pl-5 pr-5 pt-2 pb-2">
              {/* <label className="mr-4">Integrated Marketing ($299.00)</label>
              <div><button type="button" className="btn btn-orange text-nowrap">Change Plan</button></div> */}
            </div>
            <div className="d-flex head-prof-area">
              <label className="mr-2">
                Hi{" "}
                {authentication_ref.current?.user_info?.response?.first_name ||
                  ""}
              </label>
              <NavDropdown
                title={
                  <img
                    className="head-prof-img"
                    src={avatar}
                    alt="Profile"
                    width="40"
                  />
                }
                menualign="right"
                id="dropdown-menu-align-right"
                className="normal-dropdown"
              >
                <NavDropdown.Item
                  href={`https://${authentication_ref?.current?.retailer_info?.response?.domain_url}/retailer/settings/view/`}
                  target="_self"
                  rel="noopener noreferrer"
                >
                  Settings
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="https://etailpet.atlassian.net/servicedesk/customer/portal/2/user/login?destination=portal%2F2"
                  target="_self"
                  rel="noopener noreferrer"
                >
                  Help
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={`https://${authentication_ref?.current?.retailer_info?.response?.domain_url}/site-admin/logout/`}
                  onClick={handleLogout}
                >
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </div>
          </Form>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

Header.propTypes = {
  collapseSidebar: PropTypes.func,
  toggleSidebar: PropTypes.func,
  collapsed: PropTypes.bool,
  toggled: PropTypes.bool,
  authentication_state: PropTypes.object,
  fetchUserInformation: PropTypes.func,
  fetchTimeZoneList: PropTypes.func,
  time_zone_list_state: PropTypes.object,
  sendTimeZoneStoreId: PropTypes.func,
  set_time_zone_state: PropTypes.object,
};

const mapStateToProps = ({
  sidebar,
  authentication,
  time_zone_list,
  set_time_zone,
}) => ({
  collapsed: sidebar.collapsed,
  toggled: sidebar.toggled,
  authentication_state: authentication,
  time_zone_list_state: time_zone_list,
  set_time_zone_state: set_time_zone,
});

export default connect(mapStateToProps, {
  collapseSidebar: updateSidebarCollapse,
  toggleSidebar: updateSidebarToggle,
  fetchUserInformation: getUserInformation,
  fetchTimeZoneList: fetchTimeZone,
  sendTimeZoneStoreId: setStoreTimeZone,
})(Header);
